module.exports = __webpack_public_path__ + "img/skilltech-platform-preview.8ea0e7e1.png";